import type { CSSProperties } from "react";
import "./provider-mark.css";

type MarkWindow = { file: string; source: [number, number]; rect: [number, number, number, number] };
const reference = (category: string, rect: MarkWindow["rect"]): MarkWindow => ({ file: `/assets/lobby-${category}-reference.png`, source: [1024, 1536], rect });
// Original supplied marks and precise windows of the supplied reference images.
// Unknown suppliers keep their actual API code; never borrow another brand's logo.
const marks: Record<string, MarkWindow> = {
  PG: { file: "/assets/pg-provider-mark-reference.jpg", source: [1280, 640], rect: [212, 96, 884, 446] },
  JDB: { file: "/assets/jdb-provider-mark-reference.jpg", source: [1280, 640], rect: [140, 94, 1000, 440] },
  PP: reference("slots", [819, 316, 166, 83]),
  CQ9: reference("slots", [829, 895, 153, 64]),
  MG: reference("slots", [819, 1186, 164, 62]),
  AG: reference("live", [522, 48, 128, 78]),
  EVO: reference("live", [468, 567, 173, 60]),
  SEXY: reference("live", [500, 813, 147, 83]),
  BBIN: reference("board", [530, 1179, 173, 78]),
  KY: reference("board", [538, 128, 155, 101]),
  LEG: reference("board", [564, 478, 91, 126]),
  IBC: reference("sports", [522, 43, 157, 72]),
  SBO: reference("sports", [537, 324, 158, 87]),
  FB: reference("sports", [559, 894, 112, 70]),
  IM: reference("sports", [561, 1186, 98, 67]),
  IA: reference("esports", [503, 615, 117, 84]),
  VR: reference("lottery", [525, 744, 137, 83]),
};

function markStyle(mark: MarkWindow): CSSProperties {
  const [sourceWidth, sourceHeight] = mark.source;
  const [x, y, width, height] = mark.rect;
  return {
    aspectRatio: `${width} / ${height}`,
    backgroundImage: `url('${mark.file}')`,
    backgroundSize: `${sourceWidth / width * 100}% ${sourceHeight / height * 100}%`,
    backgroundPosition: `${x / (sourceWidth - width) * 100}% ${y / (sourceHeight - height) * 100}%`,
  };
}

export function ProviderMark({ provider }: { provider: string }) {
  const code = provider.trim().toUpperCase();
  // Fishing and lottery share BBIN brand artwork, never provider account identities.
  const artwork = marks[code === "BBBY" || code === "BBCP" ? "BBIN" : code];
  const style = code === "PT" ? { aspectRatio: "148 / 32", backgroundImage: "url('/assets/provider-marks/playtech.svg')", backgroundSize: "contain", backgroundPosition: "center" } : artwork && markStyle(artwork);
  return <span className={`mobile-provider-mark${style ? "" : " mobile-provider-mark--text"}`} data-provider={code} aria-hidden="true">
    {style ? <span className="mobile-provider-mark__image" style={style}/> : <span>{code}</span>}
  </span>;
}
